var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLeftMenu5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18.723mm",
    height: "11mm",
    viewBox: "0 0 18.723 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath846"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.168 144.5h53.072v31.181h-53.072z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-193.46 -124.62)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 187.75 186.59)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath846)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m16.347 160.51c-0.05972-0.0345-0.11945-0.069-0.17902-0.1035 0.05972 0.0345 0.1193 0.069 0.17902 0.1035",
    fill: "#b22e4c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m69.24 170.82c0-2.685-4.2411-10.356-4.8616-10.356-0.62035 0-4.8615 7.6705-4.8615 10.356s2.1766 4.8616 4.8615 4.8616c2.685 0 4.8616-2.1766 4.8616-4.8616",
    fill: "#70bde5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m66.968 170.86c0-1.4306-1.1597-2.5901-2.59-2.5901-1.4305 0-2.5902 1.1595-2.5902 2.5901 0 1.4305 1.1597 2.59 2.5902 2.59 1.4304 0 2.59-1.1595 2.59-2.59",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.515 146.11c1.5792 2.2955 2.3962 3.9639 3.7176 6.5066 0.09109 0.1752 6.6495 1.5352 10.555 2.1705-1.0326 1.4472-1.7784 2.3427-2.357 3.3357-1.0914 1.8727-0.64706 3.5663 1.5536 3.7035 5.6019 0.3492 11.336 0.351 16.952 0.4341l1.0822-1.4611c-4.0267-0.7212-8.0536-1.4424-12.738-2.2814 1.7395-1.4244 3.0647-2.3752 4.2284-3.4938 1.7736-1.7047 1.4238-4.1046-0.86809-4.6269-6.8869-1.5687-15.086-2.8628-22.126-4.2872",
    fill: "#175583"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37.508 163.84c0-5.0141-7.9202-19.339-9.0789-19.339-1.1586 0-9.0788 14.325-9.0788 19.339s4.0648 9.0788 9.0788 9.0788c5.0141 0 9.0789-4.0647 9.0789-9.0788",
    fill: "#a1c74a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m33.266 163.92c0-2.6714-2.1655-4.8369-4.8369-4.8369s-4.8369 2.1655-4.8369 4.8369 2.1655 4.8369 4.8369 4.8369 4.8369-2.1655 4.8369-4.8369",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftMenu5);
export default __webpack_public_path__ + "static/media/left-menu-5.ecab7565381e01cb0caa2c90cd8d5c46.svg";
export { ForwardRef as ReactComponent };